import { getDataMapper, mapField, toFiniteNumber } from "@/shared";

import { mapIncomeRepairState } from "./mapDashboardMainFromServer";

export const mapDashboardRepairFromServer = getDataMapper({
    income: mapField("income", {
        sumTotal: mapField("sum_total", toFiniteNumber),
    }),
    middleReceipt: mapField("middle_receipt", toFiniteNumber),
    countContracts: mapField("count_contracts", Number),
    incomeRepairStates: mapField("income_repair_states", mapIncomeRepairState),
    graph: mapField("graph"),
});
